module.exports = __webpack_public_path__ + "05cf4265f69c3fa1.png";